module.exports = __webpack_public_path__ + "img/13.0ac39df2.png";